import { render, staticRenderFns } from "./SelectTags.vue?vue&type=template&id=431036ac&scoped=true"
import script from "./SelectTags.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectTags.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectTags.vue?vue&type=style&index=0&id=431036ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431036ac",
  null
  
)

export default component.exports